import ApiModel from 'models/api-model';
import { isNullOrUndefined } from 'utils/object-utils';

export default class TrialBalanceMappedElements extends ApiModel({
  data: {
    targetElementsMap: {},
    sourceElementsMap: {},
    sourceElementClicked: null,
    targetElementClicked: null,
  },
}) {
  processResponse({ response }) {
    const targetElementsMap = {};
    const sourceElementsMap = {};

    const mappings = response?.data || [];

    mappings.forEach((mapping) => {
      const { elementId, tbDataId, active } = mapping;

      if (
        !isNullOrUndefined(elementId) &&
        !isNullOrUndefined(tbDataId) &&
        active
      ) {
        targetElementsMap[elementId] = mapping;
        sourceElementsMap[tbDataId] = mapping;
      }
    });

    return { data: { targetElementsMap, sourceElementsMap } };
  }

  // Get the count of mapped elements
  getMappedElementsCount() {
    return Object.keys(this.data.targetElementsMap).length;
  }

  setSourceElementClicked(payload) {
    return this.merge({
      data: {
        ...this.data,
        sourceElementClicked: payload,
      },
    });
  }

  setTargetElementClicked(payload) {
    return this.merge({
      data: {
        ...this.data,
        targetElementClicked: payload,
      },
    });
  }

  getSourceElementClicked() {
    return this.data.sourceElementClicked;
  }

  getTargetElementClicked() {
    return this.data.targetElementClicked;
  }

  // Clear all data
  clear() {
    return this.merge({
      data: {
        targetElementsMap: {},
        sourceElementsMap: {},
        sourceElementClicked: null,
        targetElementClicked: null,
      },
    });
  }

  // Getters for the maps
  get targetMap() {
    return this.data.targetElementsMap;
  }

  get sourceMap() {
    return this.data.sourceElementsMap;
  }

  // Check if target element is active
  isTargetElementActive(targetElementId) {
    const mapping = this.targetMap[targetElementId];
    return mapping ? Boolean(mapping.active) : false;
  }

  // Check if source element is active
  isSourceElementActive(sourceElementId) {
    const mapping = this.sourceMap[sourceElementId];
    return mapping ? Boolean(mapping.active) : false;
  }

  isElementExistsInTargetMap(targetElementId) {
    return targetElementId in this.data.targetElementsMap;
  }

  // Helper methods for efficient lookups
  getTargetMapping(targetElementId) {
    return this.targetMap[targetElementId];
  }

  getSourceMapping(sourceElementId) {
    return this.sourceMap[sourceElementId];
  }

  // Get the corresponding source element for a target element
  getSourceElementForTarget(targetElementId) {
    const mapping = this.targetMap[targetElementId];
    return mapping?.active ? mapping.tbDataId : null;
  }

  // Get the corresponding target element for a source element
  getTargetElementForSource(sourceElementId) {
    const mapping = this.sourceMap[sourceElementId];
    return mapping?.active ? mapping.elementId : null;
  }

  isElementMapped(elementId) {
    const mapping = this.targetMap[elementId];
    return mapping?.active ? mapping.elementId : null;
  }

  // Check if an element has a mapping
  hasTargetMapping(targetElementId) {
    return targetElementId in this.targetMap;
  }

  hasSourceMapping(sourceElementId) {
    return sourceElementId in this.sourceMap;
  }
}
